<template>
<loading :show="show" :label="label" :overlay="overlay"></loading>
    <form class="form-horizontal">
        <div class="form-body">
            <div class="form-group">
                <div class="col-md-5 input-palavra">
                    <label class="control-label">Palavra Chave</label>
                    <input type="text" class="form-control" placeholder="Insira Palavra chave">
                </div>

                <div class="col-md-5 new-padding-inputs input-entidade">
                    <label class="control-label">Entidade</label>
                    <select class="form-control">
                    </select>
                </div>

                <div class="col-md-2 new-padding-inputs input-ano">
                    <label class="control-label">Ano</label>
                    <select class="form-control">
                    </select>
                </div>

                <div class="col-md-2 new-padding-inputs input-mes">
                    <label class="control-label">Mes</label>
                    <select class="form-control">
                    </select>
                </div>

                <div class="col-md-2 botao-pesquisar">
                    <label class="control-label"></label>
                    <button class="form-control btn green" style="margin-top: 8px;" v-on:click="pesquisar">Pesquisar</button>
                </div>
            </div>
        </div>
    </form>
    <hr >
    <div>
        <div class="portlet-body">
            <cp-table v-if="line == 'table1'" :dadosconteudo="dadosconteudo"></cp-table>
            <cp-table-tres v-if="line == 'table3'" :dadosconteudo="dadosconteudo"></cp-table-tres>
        </div>
    </div>
</template>
<script>
    import CpTable from '../../tables/table-t1/table.vue'
            import CpTableTres from '../../tables/table-t3/table.vue'
            import loading from 'vue-full-loading'

            export default{
                data() {
                    return{
                        dadosconteudo: {}.CpTable,
                        show: false,
                        label: 'Carregando...',
                        overlay: true
                    }
                },
                components: {
                    CpTable, CpTableTres, loading
                },
                props: {
                    line: {}
                },
                watch: {
                    $route () {
                        this.pesquisar();
                    }
                },
                ready: function () {
                    MPL.loadSelectsDiario();
                    MPL.handleFiltroDiario();
                    $('form').bind('submit',function(e){e.preventDefault();});
                    this.pesquisar();
                },
                methods: {
                    pesquisar(ev) {

                        $.ajaxSetup({
                            async: false
                        });

                        this.show = true;
                        var self = this;
                        setTimeout(function(){
                            MPL.loadDadosDiarios(1, function (links)
                            {
                                self.dadosconteudo = links[0];
								//console.log(self.dadosconteudo)
								for(var i = 0; i < self.dadosconteudo.tr.length;i++) {
									self.dadosconteudo.tr[i].descricao[0].item = self.dadosconteudo.tr[i].descricao[0].item.replace(/<br>/gi, '<p class="newp"></p>')
								}
								//console.log(self.dadosconteudo)
                                self.show = false;
                                $('.table-responsive').fadeIn('fast');
                                //console.log(self.dadosconteudo)
                            });
                        }, 200);


                        $.ajaxSetup({
                            async: true
                        });

                        // $('.table-responsive').fadeIn('fast');

                    }
                }
            }
</script>
<style scoped>
    @media (min-width: 992px){
        .input-ano{
            width: 9.666667%;
        }

        .input-mes{
            width: 11.666667%;
        }

        .input-palavra{
            width: 26.3%;
        }

        .botao-pesquisar{
            float: right;
            padding-right: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// filtro3.vue?58cb0029